import { createSlice } from '@reduxjs/toolkit';
// utils
import { Api } from '../../utils/api';

import { HOME_URLS } from '../../utils/api/urls';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  banners: [],
};

const slice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET Banners Data
    getBannerSuccess(state, action) {
      state.isLoading = false;
      state.banners = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Exported so the homepage bundle (slices/homeBundle.js) can fill `banners`
// without reaching into the slice internals.
export const { getBannerSuccess } = slice.actions;

// ----------------------------------------------------------------------

export function getBanners() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Api.unget(HOME_URLS.banners);
      dispatch(slice.actions.getBannerSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}